import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'editing-tool/src/app/shared/shared.module';

@NgModule({
    declarations: [
    ],
    imports: [
        RouterModule,
        SharedModule
    ]
})
export class LayoutModule { }
